import { AuditPage } from "./pages/AuditPage.js";
import { AgentKeysPage } from "./pages/AgentKeysPage.js";
import { RetailersPage } from "./pages/RetailersPage.js";
import { Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout.js";
import { EmptyState, Spinner } from "./components/ui.js";
import { useSession } from "./hooks/useSession.js";
import { CategoriesPage } from "./pages/CategoriesPage.js";
import { ContactPage } from "./pages/ContactPage.js";
import { InventoryPage } from "./pages/InventoryPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { ReportsPage } from "./pages/ReportsPage.js";
import { UsersPage } from "./pages/UsersPage.js";
import { WhatnotPage } from "./pages/WhatnotPage.js";

export function App() {
  const session = useSession();

  if (session.isLoading) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <Spinner label="Starting…" />
      </div>
    );
  }

  if (!session.data) {
    return <LoginPage />;
  }

  const isAdmin = session.data.role === "admin";
  const canSeeMessages = isAdmin || session.data.role === "manager";

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="audit" element={isAdmin ? <AuditPage /> : <EmptyState title="Administrators only" />} />
        <Route path="agent-keys" element={isAdmin ? <AgentKeysPage /> : <EmptyState title="Administrators only" />} />
        <Route index element={<InventoryPage />} />
        <Route path="retailers" element={canSeeMessages ? <RetailersPage /> : <EmptyState title="No access" hint="Retailer management is available to administrators and managers." />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="whatnot" element={canSeeMessages ? <WhatnotPage /> : <EmptyState title="No access" hint="Whatnot listing management is available to administrators and managers." />} />
        <Route
          path="users"
          element={
            isAdmin ? (
              <UsersPage />
            ) : (
              <EmptyState
                title="Administrators only"
                hint="You do not have access to user management."
              />
            )
          }
        />
        <Route
          path="categories"
          element={
            canSeeMessages ? (
              <CategoriesPage />
            ) : (
              <EmptyState
                title="No access"
                hint="Category management is available to administrators and managers."
              />
            )
          }
        />
        <Route
          path="messages"
          element={
            canSeeMessages ? (
              <ContactPage />
            ) : (
              <EmptyState
                title="No access"
                hint="Contact messages are available to administrators and managers."
              />
            )
          }
        />
      </Route>
    </Routes>
  );
}

